// src/services/messageServices.js
import api from "../api/CustomerApi";

export const sendMessage = async ({
  sender_id,
  sender_type,
  receiver_id,
  receiver_type,
  message,
  image,
}) => {
  const formData = new FormData();

  formData.append("sender_id", String(sender_id));
  formData.append("sender_type", sender_type);
  formData.append("receiver_id", String(receiver_id));
  formData.append("receiver_type", receiver_type);

  if (message && String(message).trim() !== "") {
    formData.append("message", message);
  }

  // append image file
  if (image instanceof File) {
    formData.append("image", image, image.name);
  }

  const response = await api.post("/messages", formData, {
    headers: {
      "Content-Type": "multipart/form-data", // ✅ override JSON header
      Accept: "application/json",
    },
  });

  return response.data;
};

export const getConversation = async ({
  sender_id,
  sender_type,
  receiver_id,
  receiver_type,
}) => {
  const response = await api.post("/messages/conversation", {
    sender_id,
    sender_type,
    receiver_id,
    receiver_type,
  });

  return response.data;
};

export const getAllMessages = async () => {
  const response = await api.get("/messages");
  return response.data;
};

export const getMessageById = async (id) => {
  const response = await api.get(`/messages/${id}`);
  return response.data;
};

export const deleteMessage = async (id) => {
  const response = await api.delete(`/messages/${id}`);
  return response.data;
};

export default {
  sendMessage,
  getConversation,
  getAllMessages,
  getMessageById,
  deleteMessage,
};